import '@assets/styles/pages/site-visit-recording-controls-modal.scss';
import { ReactElement, useEffect } from 'react';
import { Modal } from '@components/common/modal/modal';
import { useSiteVisitRecordingStore } from '@store/siteVisitRecordingStore';
import { SiteVisitRecordingControlsPanel } from './SiteVisitRecordingControlsPanel';
import { useSiteVisitRecordingSessionState } from './useSiteVisitRecordingSessionState';

/** Recording controls in the app modal (Visit Recorded page — post–visit feedback only). */
export function SiteVisitRecordingControlsModal(): ReactElement {
	const { isActive } = useSiteVisitRecordingSessionState();
	const uploadOnStop = useSiteVisitRecordingStore((s) => s.uploadOnStop);
	const modalOpen = isActive && uploadOnStop;

	useEffect(() => {
		if (modalOpen) {
			// Push a dummy state to trap the back button
			window.history.pushState(null, '', window.location.href);

			const handlePopState = (): void => {
				// Prevent going back by pushing the state again
				window.history.pushState(null, '', window.location.href);
			};

			const handleBeforeUnload = (e: BeforeUnloadEvent): void => {
				e.preventDefault();
				e.returnValue = '';
			};

			window.addEventListener('popstate', handlePopState);
			window.addEventListener('beforeunload', handleBeforeUnload);

			return (): void => {
				window.removeEventListener('popstate', handlePopState);
				window.removeEventListener('beforeunload', handleBeforeUnload);
			};
		}
	}, [modalOpen]);

	return (
		<Modal
			modalTitle="BDE Feedback"
			modalId="siteVisitRecordingControls"
			className="dialog-sm pt-25 site-visit-recording-controls-dialog"
			modalOpen={modalOpen}
			isEscAllow={false}
		>
			{modalOpen ? (
				<div className="site-visit-recording-controls-modal">
					<SiteVisitRecordingControlsPanel variant="modal" className="site-visit-recording-controls-modal-panel" />
				</div>
			) : null}
		</Modal>
	);
}
